import { getAuthState, STATE } from '../../frontend/src/composables/useAuth';

const protectedRoutes = [ '@-slug', 'streaming', 'stripe-success', 'stripe-cancel' ];

export default defineNuxtRouteMiddleware(async (to, _from) => {
  let state;

  if (to.meta?.skipAuthMiddleware) {
    return;
  }

  if (import.meta.server) {
    // Server side
    const isAuthorized = useRequestEvent()?.context?.isAuthorized;
    state = isAuthorized ? STATE.LOGGED_IN : STATE.LOGGED_OUT;

  } else {
    // Client side
    state = await getAuthState();
  }

  if ( protectedRoutes.includes(String(to.name)) ) {
    if (state === STATE.LOGGED_OUT) {
      return navigateTo('/login');
    }

    if (state === STATE.MFA_REQUIRED) {
      return navigateTo('/mfa');
    }

    if (state === STATE.EMAIL_VERIFICATION_REQUIRED) {
      return navigateTo('/email-not-verified');
    }

    return;
  }


  if (state === STATE.LOGGED_IN) {
    return navigateTo({ name: '@-slug' });
  }
});
